<template>
  <div
    class="
      tw-w-[421px]
      tw-border-0
      tw-border-l
      tw-border-sf-neutral-lighter-2
      tw-border-solid
      tw-flex
      tw-flex-col
    "
  >
    <header
      class="
        tw-h-[60px]
        tw-flex
        tw-justify-between
        tw-items-center
        tw-px-4
        tw-py-3
        tw-border-0
        tw-border-b
        tw-border-sf-neutral-lighter-2
        tw-border-solid
      "
    >
      <div class="tw-font-medium tw-text-6 tw-px-1">
        {{ sidebarTitle }}
        <SfIndicatorCount ai>{{ suggestionCount }}</SfIndicatorCount>
      </div>
      <SfButtonInverted
        variant="dark"
        class="tw-w-9 tw-h-9"
        data-testid="close-assistant-suggestions-button"
        @click="emit('toggle-sidebar')"
      >
        <i class="fa fa-arrow-right" />
      </SfButtonInverted>
    </header>
    <div
      class="tw-p-4 tw-h-full tw-overflow-y-auto"
      data-testid="talking-point-suggestions"
    >
      <div
        v-if="loadingSuggestions"
        class="
          tw-flex
          tw-items-center
          tw-gap-4
          tw-px-4
          tw-py-9
          tw-bg-sf-ai-subtle
          tw-text-sf-ai-darker
          tw-rounded-lg
          tw-mb-6
        "
      >
        <div
          class="
            sf-spinner sf-spinner-primary sf-spinner-l
            tw-border-sf-ai tw-h-[30px] tw-w-[30px]
            tw-flex-[0_0_30px]
          "
        ></div>
        <div>
          {{ loadingLabel }}
        </div>
      </div>
      <div v-else class="tw-flex tw-flex-col tw-gap-4">
        <talking-point-suggestion
          v-for="suggestion in suggestions"
          :key="suggestion"
          :text="suggestion"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import useI18n from '@app/shared/vue/composables/use-I18n'
import SfButtonInverted from '@app/shared/vue/components/sf-button/sf-button-inverted.vue'
import { SfIndicatorCount } from '@app/shared/vue/components/sf-indicator'
import TalkingPointSuggestion from '@app/application/client_meetings/screens/preparation/components/talking-point-suggestion.vue'

import { useAssistantSuggestionsStore } from '@app/application/client_meetings/screens/preparation/store/assistant-suggestions'

const I18n = useI18n()
const assistantSuggestionsStore = useAssistantSuggestionsStore()

interface Props {
  suggestions: string[]
}

defineProps<Props>()

const sidebarTitle = I18n.t('client_meetings.meeting_preparation.sidebar.title')
const loadingLabel = I18n.t(
  'client_meetings.meeting_preparation.sidebar.loading'
)

const emit =
  defineEmits<{
    'toggle-sidebar'
  }>()

const { suggestionCount, loadingSuggestions } = storeToRefs(
  assistantSuggestionsStore
)
</script>
